var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.7,19.8c-0.3,0-0.5-0.1-0.7-0.3c-0.2-0.2-0.3-0.6-0.3-0.9l0.8-4.4c0.1-0.4,0.3-0.9,0.6-1.2L5,9.9l1,1 L3,13.8c-0.1,0.1-0.2,0.4-0.3,0.5l-0.7,4l4-0.7c0.1,0,0.4-0.2,0.5-0.3l2.9-2.9l1,1l-2.9,2.9c-0.3,0.3-0.8,0.6-1.2,0.6l-4.4,0.8 C1.8,19.8,1.7,19.8,1.7,19.8z M15.2,10.7l-1-1l4.3-4.3L15,1.9l-4.3,4.3l-1-1l4.5-4.5c0.2-0.2,0.5-0.3,0.9-0.4 c0.3,0,0.6,0.1,0.9,0.4l3.8,3.8C19.9,4.8,20,5.1,20,5.4c0,0.3-0.1,0.6-0.4,0.9L15.2,10.7z M18.7,5.3C18.7,5.3,18.7,5.3,18.7,5.3 L18.7,5.3z M14.9,1.8C14.9,1.8,14.9,1.8,14.9,1.8L14.9,1.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.7,
    y: 2.8,
    transform: "matrix(0.7072 -0.707 0.707 0.7072 4.340492e-03 11.9602)",
    className: "st0",
    width: 1.4,
    height: 6.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.9,19.7c-0.2,0-0.4-0.1-0.5-0.2L0.2,6.3c-0.3-0.3-0.3-0.7,0-1l4.9-4.9c0.1-0.1,0.3-0.2,0.5-0.2l0,0 c0.2,0,0.4,0.1,0.5,0.2l13.2,13.2c0.3,0.3,0.3,0.7,0,1l-4.9,4.9C14.3,19.6,14.1,19.7,13.9,19.7z M1.7,5.8L13.9,18l3.9-3.9L5.6,1.9 L1.7,5.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.5,12.9c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.7,0-1l2.1-2.1c0.3-0.3,0.7-0.3,1,0s0.3,0.7,0,1L8,12.7 C7.8,12.9,7.7,12.9,7.5,12.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,16.8c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.7,0-1l2.1-2.1c0.3-0.3,0.7-0.3,1,0s0.3,0.7,0,1l-2.1,2.1 C12.4,16.7,12.2,16.8,12,16.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.7,8.4c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.7,0-1l2.1-2.1c0.3-0.3,0.7-0.3,1,0c0.3,0.3,0.3,0.7,0,1 L4.1,8.2C4,8.3,3.8,8.4,3.7,8.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,14.7c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.7,0-1l1.4-1.4c0.3-0.3,0.7-0.3,1,0c0.3,0.3,0.3,0.7,0,1 l-1.4,1.4C10.3,14.6,10.1,14.7,9.9,14.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.7,10.5c-0.2,0-0.4-0.1-0.5-0.2C5,10,5,9.6,5.3,9.3l1.4-1.4c0.3-0.3,0.7-0.3,1,0c0.3,0.3,0.3,0.7,0,1 l-1.4,1.4C6.1,10.4,5.9,10.5,5.7,10.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.ce2809727014c76f73df2b7518598572.svg";
export { ForwardRef as ReactComponent };